<template>
  <span>
    <a v-if="editable" type="button" class="btn btn-link no_border pull-right" @click="addElement">
      <i class="fa-light fa-plus pulsante_comando"></i>
    </a>
    <generic-table
      :key="update"
      :headerLabels="headerLabels()"
      :elements="events"
      :options="options"
      @openUrlEvent="openUrl"
      @removeElementEvent="removeItem"
    ></generic-table>
    <v-modal :start-closed="true" ref="modalGuestEvents" v-if="editable" class="medium_modal">
      <span slot="header">
        {{ i18nJS.tamponi }}
      </span>
      <div class="control-group field">
        <label class="control-label" :for="`eventi_${rand}`">{{ i18nJS['activerecord.attributes.guest_event.event_id'] }}</label>
        <div class="controls mychzn-obbligatorio">
          <v-select2
            v-model="guestEvent.event_id"
            :key="guestEvent.id"
            :options-list="optionsDecodeEvent"
            :data-ajax--url="decodesUrl"
            :id="`eventi_${rand}`"
          />
        </div>
      </div>
      <div class="control-group field obbligatorio">
        <label class="control-label" :for="`guest_event_date_${rand}`">{{ i18nJS.dateevent }}</label>
        <div class="controls form-inline">
          <datepicker v-model="guestEvent.date" :id="`guest_event_date_${rand}`" />
          <label :for="`guest_event_time_${rand}`">-</label>
          <timepicker v-model="guestEvent.time" :id="`guest_event_time_${rand}`" />
        </div>
      </div>
      <div class="control-group">
        <div class="controls">
          <label class="checkbox" :for="`guest_event_war_${rand}`">
            <input type="checkbox" v-model="guestEvent.war" :id="`guest_event_war_${rand}`" />
            {{ i18nJS.war }}
          </label>
        </div>
      </div>
      <div class="control-group">
        <label class="checkbox" :for="`guest_event_notes_${rand}`">{{ i18nJS.notes }}</label>
        <div class="controls">
          <rich-text-editor :model="guestEvent" :attribute="'notes'" :id="`guest_event_notes_${rand}`" :rows="5" />
        </div>
      </div>
      <a slot="footer" ref="btnSave" class="btn btn-success" href="javascript:void(0)" @click="save">
        {{ i18nJS['save'] }}
      </a>
    </v-modal>
  </span>
</template>
<script>
import vSelect2 from '../vSelect2';
import genericTable from '../genericTable/genericTable';
import apiConnector from '@/epersonam/apiConnector';
import { RandomNumber } from '§/mixin/commonMixins.js';
import { LabelApi } from '@/epersonam/mixins/labels.js';
import vModal from '../vModal';
import datepicker from '../datepicker';
import timepicker from '../timepicker';
import richTextEditor from '../richTextEditor';

export default {
  name: 'guestEvents',
  props: { editable: { type: Boolean, default: false }, gpdsId: Number, type: Array, serializer: String, columnKeys: Object },
  mixins: [LabelApi, RandomNumber],
  components: {
    vSelect2,
    genericTable,
    vModal,
    datepicker,
    timepicker,
    richTextEditor,
  },
  data() {
    return {
      guestEvents: [],
      modalTitle: '',
      guestEvent: {},
      update: false,
      options: {
        modal: null,
        actionColumnEnabled: this.editable,
        canOpenUrl: this.editable,
        canDeleteRow: this.editable,
        actionButtons: [],
        htmlContent: true,
      },
    };
  },
  computed: {
    events() {
      const guestsOrdered = [...this.guestEvents];
      return guestsOrdered.sort(this.compareDate).map((ge) => Object.keys(this.columnKeys).map((key) => ge[key]));
    },
    decodesUrl() {
      let url = '/it/decodes_configs/autocomplete/guest/eventi.json';
      if (this.type.length <= 0) return url;

      this.type.forEach((type) => (url = Utils.addGetParam(url, 'only_type[]', type, false)));
      return url;
    },
    url() {
      return `/it/guest_period_data_sets/${this.gpdsId}/guest_events.json?serializer=${this.serializer}&paginate=false`;
    },
    optionsDecodeEvent() {
      return this.guestEvent ? [[this.guestEvent.get_event, this.guestEvent.event_id]] : [];
    },
  },
  async beforeMount() {
    this.neededlabels = Object.values(this.columnKeys).concat([
      'tipo_evento',
      'war',
      'dateevent',
      'command.confirm',
      'tamponi',
      'activerecord.attributes.guest_event.event_id',
    ]);
    await this.setupLabels();
  },
  mounted() {
    if (this.$refs.modalGuestEvents) this.modal = $(this.$refs.modalGuestEvents.$el);
    this.getEvents();
    this.update = !this.update;
  },
  methods: {
    headerLabels() {
      return Object.values(this.columnKeys).map((label) => this.i18nJS[label]);
    },
    compareDate(a, b) {
      if (a.db_date < b.db_date) return 1;
      if (a.db_date > b.db_date) return -1;

      return 0;
    },
    addElement() {
      this.guestEvent = {
        guest_period_data_set_id: this.gpdsId,
        date: moment().format(i18nJS.time.formats.date_only),
        time: moment().format('HH:mm'),
      };
      this.modal.modal('show');
    },
    removeItem(element, index) {
      if (this.guestEvents[index] && confirm(this.i18nJS.command.confirm)) {
        const id = this.guestEvents[index].id;
        Loader.show();
        apiConnector()
          .delete(`/it/guest_period_data_sets/${this.gpdsId}/guest_events/${id}.json`)
          .then(() => {
            this.guestEvents = this.guestEvents.filter((ev) => id != ev.id);
          })
          .finally(() => Loader.hide());
      }
    },
    save() {
      const { get_event, esito_tamponi, id, date_start_pos, ...params } = this.guestEvent;
      Loader.show();
      if (id) {
        apiConnector()
          .put(`/it/guest_period_data_sets/${this.gpdsId}/guest_events/${id}.json?serializer=${this.serializer}`, { guest_event: params })
          .then(({ data }) => {
            const index = this.guestEvents.findIndex((t) => t.id === data.id);
            this.$set(this.guestEvents, index, data.data.attributes);
            this.modal.modal('hide');
          })
          .finally(() => Loader.hide());
      } else {
        apiConnector()
          .post(this.url, { guest_event: params })
          .then(({ data }) => {
            this.guestEvents.push(data.data.attributes);
            this.modal.modal('hide');
          })
          .finally(() => Loader.hide());
      }
    },
    openUrl(guestEvent, index) {
      this.guestEvent = this.guestEvents[index];
      this.modal.modal('show');
    },
    getEvents() {
      let new_url = this.url;
      if (this.type.length <= 0) {
        new_url = Utils.addGetParam(new_url, 'q[event_id_in][]', 'null', false);
      } else {
        this.type.forEach((type) => {
          new_url = Utils.addGetParam(new_url, 'q[event_id_in][]', type, false);
        });
      }
      apiConnector()
        .get(new_url)
        .then(({ data }) => {
          this.guestEvents = data.data.map((ge) => ge.attributes);
        });
    },
  },
};
</script>
